import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-black/5 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="font-display text-2xl tracking-tight">Offer Express<span className="text-[#0055FF]">.</span></div>
          <p className="text-sm text-neutral-500 mt-3 max-w-sm">
            One cashback-tracked shopping club. Click any brand, shop as usual, and let us handle the tracking end-to-end — from your first click to the postback that lands cashback in your wallet.
          </p>
          <div className="badge-mono text-neutral-400 mt-6">offer.express · Cashback on every ₹</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-3">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/marketplace?type=ecom&category=fashion" className="hover:text-black text-neutral-600">Fashion</Link></li>
            <li><Link to="/marketplace?type=ecom&category=beauty" className="hover:text-black text-neutral-600">Beauty</Link></li>
            <li><Link to="/marketplace?type=ecom&category=health" className="hover:text-black text-neutral-600">Health</Link></li>
            <li><Link to="/marketplace?type=ecom&category=electronics" className="hover:text-black text-neutral-600">Electronics</Link></li>
            <li><Link to="/marketplace?type=ecom" className="hover:text-black text-neutral-600">All brands</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/privacy" data-testid="footer-privacy" className="hover:text-black text-neutral-600">Privacy Policy</Link></li>
            <li><Link to="/legal/terms" data-testid="footer-terms" className="hover:text-black text-neutral-600">Terms &amp; Conditions</Link></li>
            <li><Link to="/legal/grievance" data-testid="footer-grievance" className="hover:text-black text-neutral-600">Grievance Redressal</Link></li>
            <li><Link to="/legal/refund" data-testid="footer-refund" className="hover:text-black text-neutral-600">Refund Policy</Link></li>
            <li><Link to="/legal/disclaimer" data-testid="footer-disclaimer" className="hover:text-black text-neutral-600">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="hairline" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between text-xs text-neutral-500">
        <span>© {new Date().getFullYear()} Offer Express</span>
        <span className="font-mono-accent">OE-01 · edge tracking active</span>
      </div>
    </footer>
  );
}
